

const prepareRequestBody = (body, jsonRequest) => {
  if (jsonRequest) {
    return JSON.stringify(body)
  } else {
    let formDataBody = new FormData()

    Object.keys(body).forEach((key) => {
      formDataBody.append(key, body[key])
    })

    return formDataBody
  }
}

const prepareRequestHeaders = ({ headers = {} }, jsonRequest) => {
  if (jsonRequest) {
    headers = {
      ...headers
    }
  }

  return headers
}

const prepareURL = (targetUrl, query) => {
  if (!query) {
    return targetUrl
  }

  let queryUrl = `${targetUrl}?`

  for (let key in query) {
    if (query.hasOwnProperty(key)) {
      queryUrl = `${queryUrl}${key}=${query[key]}&`
    }
  }

  return queryUrl
}

const requestWrapper = async (url, data = {}, jsonRequest = true) => {
  data.body = prepareRequestBody(data.body, jsonRequest)
  data.headers = prepareRequestHeaders(data, jsonRequest)

  const baseUrl = process.env.REACT_APP_API_URL
  const URL = prepareURL(baseUrl + url, data.query)

  try {
    const res = await fetch(URL, data)

    return res
  } catch (err) {
    console.log(err)
    return { err }
  }
}

const createUser = data => requestWrapper('/create_new_user',
  {
    method: 'POST',
    body: data,
  }
)

const deleteUser = data => requestWrapper('/delete_user',
  {
    method: 'DELETE',
    body: data,
  }
)

export {
  createUser,
  deleteUser,
}


// WEBPACK FOOTER //
// ./src/services/api.js